import { useMemo } from 'react';
import { FooterItem } from '.';
import Telegram from './imgs/contact-us/Telegram';
import Facebook from './imgs/contact-us/Facebook';
import Twitter from './imgs/contact-us/Twitter';
import Email from './imgs/contact-us/email';
import Medium from './imgs/contact-us/Medium';
import Discord from './imgs/contact-us/Discord';
export const usePartnerList = () => {
  return useMemo<FooterItem[]>(
    () => [
      { mediaType: 'telegram', Logo: Telegram },
      { mediaType: 'twitter', Logo: Twitter },
      { mediaType: 'medium', Logo: Medium },
      { mediaType: 'discord', Logo: Discord },
      // { mediaType: 'email', Logo: Email },
      // { mediaType: 'facebook', Logo: Facebook },
    ],
    [],
  );
};
